import React from 'react';

import { useAccount } from '@/hooks/useAccount';
import { amplitudeModule } from '@/modules/amplitude';
import { canLogEvents } from '@/utils/canLogEvents';
import { generateDownloadLink } from '@/utils/generateDownloadLink';

import { StoresLinksStyles } from './StoreLinks.styles';

export const StoreLinks = () => {
  const { user } = useAccount();

  const downloadingAppLink = React.useMemo(() => {
    return generateDownloadLink(user?.id || '');
  }, [user?.id]);

  const fireAmplitude = (storeType: string) => {
    if (canLogEvents()) {
      amplitudeModule.logEvent('download_click', {
        type: storeType,
      });
    }
  };

  return (
    <StoresLinksStyles>
      <a href={downloadingAppLink} onClick={() => fireAmplitude('appstore')}>
        <img
          src="https://d3hhlnlnie19wm.cloudfront.net/web-onb/assets/onboarding/appstore.png"
          alt="appstore"
        />
      </a>
      <a href={downloadingAppLink} onClick={() => fireAmplitude('googleplay')}>
        <img
          src="https://d3hhlnlnie19wm.cloudfront.net/web-onb/assets/onboarding/googleplay.png"
          alt="googleplay"
        />
      </a>
    </StoresLinksStyles>
  );
};
